import React, { useState } from "react";

import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import moment from "jalali-moment";
import Context from "../../../../../context";
import {
  DRIVER_OFFLINE_PAYER_TYPE,
  MONTH,
  OFFLINE_PAYER_WAY,
  SETTELMENT_FILTER,
} from "../../../../../values/dropdownItems";
import { IItem } from "../../../../../types/common.interface";
import utils from "../../../../../utils";
import constants from "../../../../../values/constants";
import {
  CustomInput,
  CustomModal,
  CustomView,
  TableHeader,
  TableNullData,
  UserInformation,
} from "../../../../../components";
import values from "../../../../../values";
import convertNumberToPrice from "../../../../../utils/convertNumberToPrice";
import {SHOW_DETAILS_DRIVER_FINANCIAL_REPORT} from "../../../../../values/tableHeaders";

const Detail = ({ selected }: { selected: any }) => {
  const { showModal, setShowModal, selectedDriver } = React.useContext(
    Context.DriverScreen
  );
  const [selectedFactor, setSelectedFactor] = useState<string[]>([]);
  const [selectedPayerWay, setSelectedPayerWay] = React.useState<IItem>(
    OFFLINE_PAYER_WAY[1]
  );
  const [selectedPayerType, setSelectedPayerType] = React.useState<IItem>(
    DRIVER_OFFLINE_PAYER_TYPE[0]
  );
  const [fishNumber, setFishNumber] = React.useState<string>("");
  const [errors, setErrors] = React.useState<any>({
    factorList: "",
    fishNumber: "",
    payWay: "",
  });
  const [selectedYear, setSelectedYear] = React.useState(SETTELMENT_FILTER[0]);
  const [selectedMonth, setSelectedMonth] = React.useState<IItem>(
    MONTH.find(
      (item) => item._id === moment().locale("fa").format("jM")
    ) as IItem
  );

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  const { t } = useTranslation();

  function setUserType(evnet: string): string {
    switch(evnet) {
      case 'DRIVER'   : return 'راننده';
      case 'ADMIN'    : return 'ادمین';
      case 'COMPANY'  : return 'شرکت';
      case 'PASSENGER': return 'اولیاء';
      default         : return 'نامشخص';
    }
  }

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="show-all-service-modal-container">
      <CustomModal
        onClose={() => setShowModal!("CLOSED_FACTOR")}
        open={showModal === "DRIVER_TRANSACTION_MODAL"}
        minWidth={"70vw"}
        maxWidth={"50rem"}
        height={"65vh"}
      >
        <CustomView.Container className="">
          <CustomView.Row className="user-information-container">
            <CustomView.Column>
              <UserInformation
                name={selectedDriver?.firstName}
                avatar={selectedDriver?.avatar}
                isBlock={
                  !selectedDriver?.driverInformation?.approved?.isApproved
                }
                lastName={selectedDriver?.lastName}
                phoneNumber={selectedDriver?.phoneNumber}
              />
            </CustomView.Column>
          </CustomView.Row>
          <div className="table-content-wrapper">
            <table className="dropdown">
              <TableHeader
                headers={values.tableHeaders.SHOW_DETAILS_DRIVER_FINANCIAL_REPORT}
              />
              <>
                {(selected?.factorList?.length <= 0 ||
                  !selected?.factorList) && (
                  <TableNullData text={t("driver_has_not_active_service")} />
                )}

                <tbody id="driver-table-body-container">
                  {selected?.factorList?.map((factor: any, index: number) => {
                    console.log('arash', factor)
                    return (
                      <tr
                        key={`driver-${index}`}
                        className={
                          factor?.isClose
                            ? "close-factor"
                            : factor?.status === "PAID"
                            ? "paid-row"
                            : "not-paid-row"
                        }
                      >
                        <td
                          className="pointer"
                        >
                          <UserInformation
                            avatar={factor?.student?.avatar}
                            name={factor?.student?.firstName}
                            lastName={factor?.student?.lastName}
                            phoneNumber={factor?.student?.phoneNumber}
                            isBlock={factor?.student?.approved?.isApprove}
                          />
                        </td>
                        <td
                          className="pointer"
                          // onClick={() => onClick("company", driver)}
                        >
                          <UserInformation
                            name={factor?.parent?.firstName}
                            lastName={factor?.parent?.lastName}
                            phoneNumber={factor?.parent?.phoneNumber}
                            isBlock={factor?.parent?.approved?.isApprove}
                            hideAvatar
                          />
                        </td>
                        <td>
                          {utils.convertGregorianToJalali({
                            date: factor?.oldSubscriptionDate,
                          })}
                        </td>
                        <td>
                          {utils.convertGregorianToJalali({
                            date: factor?.newSubscriptionDate,
                          })}
                        </td>
                        <td>
                          {factor?.isOnline ? 'آنلاین' : 'آفلاین'}
                        </td>
                        <td>
                          {setUserType(factor?.payerOriginType)}
                        </td>
                        <td className="pointer">
                          <div>
                            {factor?.isClose
                              ? "بسته شده"
                              : factor.status === "PAID"
                              ? "پرداخت شده"
                              : "پرداخت نشده"}
                          </div>
                        </td>
                        <td className="pointer">
                          {factor?.price && (
                            <div>
                              {convertNumberToPrice(factor?.price)} تومان
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <div className="error">
                  {errors.factorList !== "" && errors.factorList}
                </div>
              </>
            </table>
            <CustomView.Container className="">
              <>
                <CustomView.Row className="content-center">
                  <CustomView.Column medium={12}>
                    <CustomView.Row className="radio-button-group">
                      {/* <CustomView.Column
                        medium={12}
                        className="form-colum dropdown"
                      >
                        <div className="form-colum input-label right">
                          {t("payWay")}
                        </div>
                        <CustomRadioButtonGroup
                          menus={OFFLINE_PAYER_WAY}
                          selected={selectedPayerWay as IItem}
                          onClick={(event: IItem | null) => {
                            setSelectedPayerWay(event as IItem);
                            setErrors({ ...errors, payWay: "" });
                          }}
                          canNull={false}
                        />
                        <div className="error">
                          {errors.payWay !== "" && errors.payWay}
                        </div>
                      </CustomView.Column> */}
                      {/* <CustomView.Column
                        medium={12}
                        className="form-colum dropdown"
                      >
                        <div className="form-colum input-label right">
                          {t("payer")}
                        </div>
                        <CustomRadioButtonGroup
                          menus={DRIVER_OFFLINE_PAYER_TYPE}
                          selected={selectedPayerType as IItem}
                          onClick={(event: IItem | null) => {
                            setSelectedPayerType(event as IItem);
                            setErrors({ ...errors, payerType: "" });
                            // calculatePrice(
                            //   allFactors?.data?.result?.filter((item: any) =>
                            //     selectedFactor?.includes(item?._id)
                            //   ),
                            //   event as IItem
                            // );
                          }}
                          canNull={false}
                        />
                        <div className="error">
                          {errors.payerType !== "" && errors.payerType}
                        </div>
                      </CustomView.Column> */}
                      <CustomView.Column
                        medium={6}
                        className="form-colum dropdown"
                      >
                        <CustomInput
                          name="fishNumber"
                          id="fishNumber"
                          label={t("fishNumber")}
                          value={selected?.fishNumber || "پرداخت به راننده"}
                          onValueChange={(event) => {
                            setFishNumber(event.target.value);
                            setErrors({ ...errors, fishNumber: "" });
                          }}
                        />
                        <div className="error">
                          {errors.fishNumber !== "" && errors.fishNumber}
                        </div>
                      </CustomView.Column>
                      <CustomView.Column medium={6} className="form-colum">
                        {/* <CustomInput
                          name="totalPriceDriverToPay"
                          id="totalPriceDriverToPay"
                          label={t("totalPriceDriverToPay")}
                          value={
                            String(
                              convertNumberToPrice(
                                selected?.shares?.company +
                                  selected?.shares?.admin
                              )
                            ) + t("toman")
                          }
                          isDisable
                        /> */}

                        <CustomInput
                          name="totalServicePrice"
                          id="totalServicePrice"
                          label={t("totalServicePrice")}
                          value={
                            String(
                              convertNumberToPrice(selected?.totalAmount)
                            ) + t("toman")
                          }
                          isDisable
                        />
                        {selected?.isDept4Driver2Pay && (
                          <CustomInput
                            name="DebtDriver"
                            id="DebtDriver"
                            label={t("DebtDriver")}
                            value={
                              String(
                                convertNumberToPrice(
                                  selected?.priceDept4Driver2Pay
                                )
                              ) + t("toman")
                            }
                            isDisable
                          />
                        )}
                        {selected?.isDept4Pay2Driver && (
                          <CustomInput
                            name="CreditorDriver"
                            id="CreditorDriver"
                            label={t("CreditorDriver")}
                            value={
                              String(
                                convertNumberToPrice(
                                  selected?.priceDept4Pay2Driver
                                )
                              ) + t("toman")
                            }
                            isDisable
                          />
                        )}
                        {selected?.isPaid2Driver && (
                          <CustomInput
                            name="payToDriver"
                            id="payToDriver"
                            label={t("payToDriver")}
                            value={
                              String(
                                convertNumberToPrice(selected?.paidAmount)
                              ) + t("toman")
                            }
                            isDisable
                          />
                        )}
                        {selected?.isPaid4Driver && (
                          <CustomInput
                            name="receiveFromDriver"
                            id="receiveFromDriver"
                            label={t("receiveFromDriver")}
                            value={
                              String(
                                convertNumberToPrice(selected?.paidAmount)
                              ) + t("toman")
                            }
                            isDisable
                          />
                        )}
                      </CustomView.Column>
                    </CustomView.Row>
                  </CustomView.Column>
                </CustomView.Row>
                <br />
              </>
            </CustomView.Container>
          </div>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default Detail;
